import { Component, Input } from '@angular/core';
import { User } from 'ngx-login-client';



export class AssigneesComponent {
  private assignees: User[] = [];

   truncateAfter: number;
   showFullName: boolean;
   set assigneeInput(val) {
    this.assignees = val;
  }
   overlapAvatar: boolean = false;

  constructor() {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'f8-assignee',
  templateUrl: './assignee.component.html',
  styleUrls: ['./assignee.component.less']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'truncateAfter': [{ type: Input },],
'showFullName': [{ type: Input },],
'assigneeInput': [{ type: Input, args: ['assignees', ] },],
'overlapAvatar': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
